<template>
  <v-container fluid>
    <div oncopy="return false" oncut="return false" onpaste="return false">
      <v-row ref="content">
        <v-col cols="12">
          
          <v-app-bar  fixed  v-ripple class="mt-12 elevation-0">
            <v-row>
              <v-btn color="primary" class="mr-2"@click="verPdf1()" >Manual</v-btn>
              <v-btn color="secondary" @click="verPdf2()"   >Diagrama D. Partes</v-btn>
            </v-row>
          </v-app-bar>
          
          <!-- Boton para ver en que pagina esta posicionado -->
          <v-row class="mt-12">
            <v-btn color="terciario" dark fixed right fab small> {{page}} </v-btn>
          </v-row>

          <v-row justify="end" >

            <v-col cols="2" >
              <div id="Layer1" style=" height:450px; overflow: scroll; position:fixed; right:80%; left:0;">
                <v-card floating
                  @click="page =  i"
                  v-for="i in numPages"
                  :key="i"
                  elevation="16"
                  max-width="400"
                  class="mx-auto"
                >
                  <pdf2
                    ref="myPdfComponent"
                    :key="i"
                    :src="src2"
                    :page="i"
                  ></pdf2>
                  <v-divider></v-divider>
                </v-card>
              </div>
            </v-col>
            
            <v-col cols="10"  align="center"> 
              <pdf 
                v-if="creado"
                :resize="true"
                :src="pdfdata" 
                v-for="i in numPages" 
                :key="i" 
                :id="i" 
                :page="i"
              >
                <template slot="loading">
                  loading content here...
                </template>
              </pdf>
            </v-col>
          </v-row>

          <v-footer small padless fixed class="pb-2 pt-2 tercierio" color="grey lighten-2">
            <v-spacer></v-spacer>
            <v-btn color="primary"  
              @click="page > 1 ? page-- : page=page" 
              small fab class="mr-2">
              <v-icon right>arrow_back_ios</v-icon>
            </v-btn>

            <v-btn color="secondary" dark  
              @click="page < numPages ? page++ : 1" 
              small fab class="mr-2">
              <v-icon center>arrow_forward_ios</v-icon>
            </v-btn>

            <v-text-field 
              dense
              outlined
              name="name"
              label="Buscar"
              v-model="palabra"
              hide-details
            ></v-text-field>

            <v-btn
              fab
              color="primary" class="white--text mb-10" 
              @click="arriba"
              fixed
              bottom
              right
              small
              >
              <v-icon>keyboard_arrow_up</v-icon>
            </v-btn>


            <!-- <v-btn color="success" @click="FindNext(palabra)" fab small class="ml-2"><v-icon>search</v-icon></v-btn> -->
            <v-btn color="terciario darken-1" @click="find2(palabra)" fab small class="ml-2" dark><v-icon>search</v-icon></v-btn>
              
            <v-btn color="primary darken-3" dark @click="cols > 1 ? cols-- : cols=cols" fab small class="mx-2">
              <v-icon>zoom_out</v-icon>
            </v-btn>

            <v-btn color="secondary darken-3" dark @click="cols < 12 ? cols++ : cols=cols" fab small class="mr-2">
              <v-icon>zoom_in</v-icon>
            </v-btn>

            <v-btn color="info" dark @click="ayuda= true" fab small >
              <v-icon>help</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
          </v-footer>


        </v-col>
      </v-row>

       <v-dialog
        v-model="ayuda"
        max-width="290"
        >
        <v-card>
          <v-card-title class="headline">SOPORTE SMIPACK</v-card-title>

          <v-divider></v-divider>

          <div class="mx-6">
            Comunícate con nosotros a través de las siguientes opciones
          </div>

          <br/>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" href="mailto:aclientes@mikai.com.mx" fab><v-icon>email</v-icon></v-btn>
            <v-spacer></v-spacer>  
            <v-btn color="primary" href="https://api.whatsapp.com/send?phone=528141641814&text=" target="_blank" fab><v-icon>mdi-whatsapp</v-icon></v-btn>
            <v-spacer></v-spacer>  
          </v-card-actions>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              text
              @click="ayuda = false"
            >
              Cancelar
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
    <v-dialog
      v-model="dialog"
      max-width="350"
    >
      <v-card>
        <v-card-title class="headline">Aviso informativo</v-card-title>

        <v-card-text>
          Los docuementos pueden tomar un momento en renderizar
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            OKEY
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container style="height: 400px;" v-if="cargando">
      <v-row
        class="fill-height"
        align-content="center"
        justify="center"
      >
        <v-col
          class="subtitle-1 text-center"
          cols="12"
        >
          Espera un momento, renderizando
        </v-col>
        <v-col cols="6">
          <v-progress-linear
            color="deep-purple accent-4"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-col>
      </v-row>
    </v-container>


    

  </v-container>
</template>

<script>
import pdfvuer from 'pdfvuer'
import pdf2 from 'vue-pdf'


  export default {
    components: {
      pdf: pdfvuer,
      pdf2,
    },
    data () {
      return {
        ayuda: false,
        cargando: true,
        dialog: false,
        vista: false,
        src2: undefined,

        page: 1,
        numPages: 0,
        pdfdata: undefined,
        errors: [],
        scale: 'page-width',
        palabra:'',

        docum1:'',
        docum2:'',
        detalle:'',
        verDocumento:'',

        creado: false,

        bandera: true,
      }
    },
    computed: {
      formattedZoom () {
          return Number.parseInt(this.scale * 80);
      },

      tamanioDisplay () {
        console.log(this.$vuetify.breakpoint)
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return this.$vuetify.breakpoint.height
          break;
          case 'sm': 
            return this.$vuetify.breakpoint.height
          break;
          case 'md':
            return this.$vuetify.breakpoint.height
          break;
          case 'lg':
            return this.$vuetify.breakpoint.height 
          break;
          case 'xl':
            return this.$vuetify.breakpoint.height
          break;
        }
      },
      
    },
    mounted () {
      this.docum1 = this.$route.params.detalle.docum1
      this.docum2 = this.$route.params.detalle.docum2
      this.detalle = this.$route.params.detalle
      this.verDocumento = this.docum2
      var url2 = 'https://support-smipack.com/pdf/' + this.verDocumento
      this.getPdf(url2)
      this.getPdf2(url2)
    },

    watch: {

      palabra(){
        this.bandera = true
      },

      // show: function (s) {
      //   if(s) {
      //     this.getPdf();
      //   }
      // },
      page: function (p) {
        if( window.pageYOffset <= this.findPos(document.getElementById(p)) || ( document.getElementById(p+1) && window.pageYOffset >= this.findPos(document.getElementById(p+1)) )) {
          window.scrollTo(0,this.findPos(document.getElementById(p)));
          // document.getElementById(p).scrollIntoView();
        }
      },

    },

    methods: {
      getPdf (url) {
        window.scrollTo(500, 0);
        this.page = 1
        this.cargando = true
        setTimeout(()=>{ this.cargando = false }, 7000);
        var self = this;
        this.creado = false
        this.pdfdata = undefined
        this.pdfdata = pdfvuer.createLoadingTask(url);
        this.pdfdata.then(pdf => {
          this.creado = true
          this.numPages = pdf.numPages;
          window.onscroll = function() { 
            self.creado = true
            self.changePage() 
          }
        });
      },

      getPdf2(url){
        this.src2 = undefined  
        this.src2 = pdf2.createLoadingTask(url);
        this.src2.promise.then(pdf => {
          this.numPages2 = pdf.numPages;
        });
      },

      changePage () {
        var i = 1, count = Number(this.numPages);
        do {
          if(window.pageYOffset >= this.findPos(document.getElementById(i)) && 
              window.pageYOffset <= this.findPos(document.getElementById(i+1))) {
            this.page = i
          }
          i++
        } while ( i < count)
        if (window.pageYOffset >= this.findPos(document.getElementById(i))) {
          this.page = i
        }
      },

      findPos(obj) {
        return obj.offsetTop;
      },

      arriba(){
        window.scrollTo(500, 0);
      },

      FindNext (val) {
        var str = val;

        var supported = false;
        var found = false;
        if (window.find) {  
          console.log('1')      // Firefox, Google Chrome, Safari
          supported = true;
              // if some content is selected, the start position of the search 
              // will be the end position of the selection
              var aCaseSensitive, aBackwards, aWrapAround = true, aWholeWord, aSearchInFrames, aShowDialog

          found = window.find(str, aCaseSensitive, aBackwards, aWrapAround,
            aWholeWord, aSearchInFrames, aShowDialog);
          // found = window.find(str);
        }
        else {
          console.log('2') 
          if (document.selection && document.selection.createRange) { // Internet Explorer, Opera before version 10.5
            console.log('3') 
            var textRange = document.selection.createRange ();
            if (textRange.findText) {   // Internet Explorer
              console.log('4') 
              supported = true;
                // if some content is selected, the start position of the search 
                // will be the position after the start position of the selection
              if (textRange.text.length > 0) {
                console.log('5') 
                textRange.collapse (true);
                textRange.move ("character", 1);
              }

              found = textRange.findText (str);
              if (found) {
                console.log('6') 
                textRange.select ();
              }
            }
          }
        }

        if (supported) {
          if (!found) {
            alert ("The following text was not found:\n" + str);
          }
        }
      },

      find2(str){
        var eventObj = document.createEventObject ? document.createEventObject() : document.createEvent("Events");

        if(eventObj.initEvent){
          eventObj.initEvent("keydown", true, true);
        }

        eventObj.keyCode = 32;
        eventObj.which = 32;
        eventObj.key=' ';
        eventObj.code='Space';
        document.dispatchEvent ? document.dispatchEvent(eventObj) : document.fireEvent("onkeydown", eventObj); 

        if(this.bandera){
          console.log('1')
          var element = this.$refs.content
          var selection = window.getSelection();        
          var range = document.createRange();
          range.selectNodeContents(element);
          selection.removeAllRanges();
          window.find(str);

          var aCaseSensitive, aBackwards, aWrapAround = true, aWholeWord, aSearchInFrames, aShowDialog

          window.find(str, aCaseSensitive, aBackwards, aWrapAround,
            aWholeWord, aSearchInFrames, aShowDialog);

          this.bandera = false
        }else{
          this.FindNext(str)
        }
        
      },

      verPdf1(){
        this.$router.push({name:'versubserie', params:{docum: this.docum1, detalle: this.detalle}})
      },

      verPdf2(){
        this.$router.push({name:'versubserie2', params:{docum: this.docum2, detalle: this.detalle}})
      },
    }
  }
</script>

<style lang="css" scoped>
  #buttons {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  /* Page content */
  .content {
    padding: 16px;
  }
</style>